angular.module('bmsApp.settings').factory('EcomRouteConfigurationSvc', function ($http, $log, $window, $q, CRUDSvc) {

	return {
		index: function(params){
			return CRUDSvc.get('api/settings/ecom-route-config/index',params);
		},
		read: function (licenceId) {
			return CRUDSvc.get('api/settings/ecom-route-config/read/' + licenceId);
		},
		save: function (params) {
			return CRUDSvc.post('api/settings/ecom-route-config/save', params);
		}
	}

});

